<template>
  <div class="product__accordion">
    <div v-if="loading" />
    <div v-else>
      <LazyHydrate when-idle>
        <SfAccordion
          :open="deviceSize && deviceSize.isDesktop ? `all` : ``"
          :multiple="true"
          transition="sf-fade"
          show-chevron
        >
          <SfAccordionItem :header="$t('Features')">
            <HTMLContent
              v-if="description"
              :content="description"
              tag="div"
              class="product__description"
            />
          </SfAccordionItem>
          <SfAccordionItem
            :header="$t(`Technical specifications`)"
            v-if="technicalSpecific"
          >
            <HTMLContent
              :content="technicalSpecific"
              tag="div"
              class="product__description"
            />
          </SfAccordionItem>
        </SfAccordion>
      </LazyHydrate>
    </div>
  </div>
</template>

<script>
import { useContext } from '@nuxtjs/composition-api';
import LazyHydrate from 'vue-lazy-hydration';
import { SfAccordion } from '@storefront-ui/vue';
import HTMLContent from '~/components/HTMLContent.vue';

export default {
  name: 'ProductAccordion',
  components: {
    LazyHydrate,
    HTMLContent,
    SfAccordion,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props) {
    const { app } = useContext();
    const description = props?.product?.description?.html || '';
    const technicalSpecific = props?.product?.technical_specifications;
    return {
      deviceSize: app.context.$deviceSize,
      technicalSpecific,
      description,
    };
  },
};
</script>

<style lang="scss" scoped>
.product__accordion {
  font-family: var(--font-family--secondary);

  --accordion-item-header-justify: 'left';

  .sf-accordion-item {
    margin-bottom: 30px;
    button {
      height: auto;
    }
  }
  .product__description {
    padding: 1.875rem;
    background-color: var(--c-grey-1);
    color: var(--c-grey-2);
    font-size: var(--font-size--3xs);
  }
}
@media (max-width: $tablet-max) {
  .product__accordion {
    .product__description {
      padding: 30px;
    }
  }
}
</style>

<style lang="scss">
.product__accordion {
  .sf-accordion-item__header {
    padding: 20px 20px;
    border-bottom: solid 1px var(--c-grey-2);
    font-family: var(--font-family--primary);
    font-size: var(--font-size--xs);
    color: var(--c-grey-8);
    @include for-desktop {
      font-size: var(--font-size--sm);
    }
    &.is-open {
      --accordion-item-header-color: var(--c-grey-2);
      --chevron-color: var(--c-grey-2);
    }
    .sf-accordion-item__chevron {
      margin-left: 20px;
    }
  }
  &__review-container > button {
    font-family: var(--font-family--primary);
    font-size: var(--font-size--sm);
  }
  .product__description {
    br:nth-of-type(odd) {
      display: none;
    }
    br:nth-of-type(even) {
      display: block;
    }
    hr {
      display: none;
    }
    table#rtb {
      width: 100%;
      background-color: var(--c-grey-1);
      color: var(--c-grey-2);
      hr: {
        display: none;
      }
      tbody {
        width: 100%;
        tr {
          width: 100%;
          @include to-mobile-max {
            display: grid;
          }
          td {
            width: 50%;
            @include to-mobile-max {
              width: 100%;
            }
            table#rtb_text {
              width: 100%;
              padding: 14%;
              br {
                display: none;
              }
              tr,
              div {
                th {
                  font-family: var(--font-family--secondary-bold);
                }
                td {
                  font-family: var(--font-family--secondary);
                }
              }
            }
            img {
              object-fit: cover;
              width: 100%;
              height: 100%;
            }
          }
          &:nth-child(odd) {
            td:nth-child(1) {
              order: 2;
            }
            td:nth-child(2) {
              order: 1;
            }
          }
        }
      }
    }
    strong {
      font-family: var(--font-family--secondary-bold);
    }
  }
  .sf-accordion-item {
    button {
      height: auto;
      display: flex;
      justify-content: space-between;
    }
    &__content {
      padding: 0;
    }
  }
}
</style>
